import { FieldValues } from 'react-hook-form';

import { useResponsive } from '@/hooks/useResponsive';

import { SelectProps } from './Select.interface';
import { SelectDesktop } from './SelectDesktop';
import { SelectMobile } from './SelectMobile';

export function Select<FormPayload extends FieldValues>({
  useDrawerOnMobile,
  ...props
}: SelectProps<FormPayload>) {
  const { isDesktop } = useResponsive();

  if (!isDesktop && useDrawerOnMobile) return <SelectMobile {...props} />;

  return <SelectDesktop {...props} />;
}
